import FormattedName from 'I18n/components/FormattedName';
import { useMemo, useState } from 'react';
import UIModal from 'UIComponents/dialog/UIModal';
import UIForm from 'UIComponents/form/UIForm';
import productApprovalsApi from '../../data/productApprovalsApi';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { useFetchUsersByScope } from '../../hooks/useFetchUsersByScope';
import { requestedAccessToApprovalsSuccessAlert } from '../../utils/alertUtils';
import { getErrorSubCategoryFromError } from '../../utils/errorUtils';
import ApprovalRequestAccessModalBody from './ApprovalRequestAccessModalBody';
import ApprovalRequestAccessModalFooter from './ApprovalRequestAccessModalFooter';
import ApprovalRequestAccessModalHeader from './ApprovalRequestAccessModalHeader';
import * as trackingConstants from '../../constants/trackingConstants';
import { trackInteraction } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalRequestAccessModal = props => {
  const {
    closeRequestAccessModal
  } = props;
  const {
    isLoading,
    users
  } = useFetchUsersByScope('super-admin');
  const [selectedSuperAdminId, setSelectedSuperAdminId] = useState();
  const [requesterMessage, setRequesterMessage] = useState();
  const [errorSubCategory, setErrorSubCategory] = useState();
  const approval = useApprovalContext();
  const superAdminUsersOptions = useMemo(() => {
    return users.map(user => ({
      text: `${user.firstName} ${user.lastName}`,
      dropdownText: /*#__PURE__*/_jsx(FormattedName, {
        givenName: user.firstName,
        familyName: user.lastName
      }),
      help: user.email,
      value: user.id
    }));
  }, [users]);
  const onChangeSelect = e => {
    setSelectedSuperAdminId(e.target.value);
  };
  const onChangeMessage = message => {
    setRequesterMessage(message);
  };
  const onSend = () => {
    if (!selectedSuperAdminId) {
      closeRequestAccessModal();
      return;
    }
    productApprovalsApi.requestAccess(approval.meta.approvalType, approval.meta.approvalAction, selectedSuperAdminId, requesterMessage).then(() => {
      requestedAccessToApprovalsSuccessAlert(approval.meta.approvalType);
      trackInteraction(trackingConstants.APPROVAL_REQUEST_ACCESS_FORM_SUBMITTED, approval.meta.approvalType);
      closeRequestAccessModal();
    }).catch(errorResponse => {
      setErrorSubCategory(getErrorSubCategoryFromError(errorResponse));
      console.error('errorSubCategory', errorSubCategory);
    });
  };
  return /*#__PURE__*/_jsx(UIModal, {
    "data-test-id": "product-approvals-request-access-modal",
    role: "dialog",
    width: 600,
    children: /*#__PURE__*/_jsxs(UIForm, {
      children: [/*#__PURE__*/_jsx(ApprovalRequestAccessModalHeader, {
        closeRequestAccessModal: closeRequestAccessModal
      }), /*#__PURE__*/_jsx(ApprovalRequestAccessModalBody, {
        errorSubCategory: errorSubCategory,
        isLoading: isLoading,
        onChangeSelect: onChangeSelect,
        onChangeMessage: onChangeMessage,
        superAdminUsersOptions: superAdminUsersOptions
      }), /*#__PURE__*/_jsx(ApprovalRequestAccessModalFooter, {
        onCancel: closeRequestAccessModal,
        onSend: onSend,
        sendButtonDisabled: !selectedSuperAdminId
      })]
    })
  });
};
export default ApprovalRequestAccessModal;